<template>
  <div class="Wx-home">
    <div v-if="route.meta.mark !== 'homedata'">
      <div class="header">
        <navhead @onGlobalSwitchLang="onGlobalSwitchLang"/>
      </div>
      <div>
        <router-view />
      </div>
      <div class="homeFoolter">
        <home-foolter />
      </div>
    </div>
    <div v-else>
      <div>
        <router-view />
      </div>
    </div>

    <!-- DeepSeek接口都需要登录才能用————宋柏欣 -->
    <DeepSeek v-if="shouldShowDeepSeek" />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import Cookies from "js-cookie";
import navhead from "@/components/wx-Nav-header";
import homeFoolter from "@/components/homeFoolter";
import DeepSeek from "@/views/DeepSeek";
const router = useRouter();
const route = useRoute();

let privatization = window.g.privatization; /// 是否私有化部署， true/是 false/否

const getToken = Cookies.get("tokenValue");

const shouldShowDeepSeek = computed(() => {
  return getToken && !privatization;
});

// 存储滚动位置的变量

const emit = defineEmits(["onGlobalSwitchLang"])

const onGlobalSwitchLang = () => {
  emit("onGlobalSwitchLang")
}

onMounted(() => {
});
onUnmounted(() => {
});
</script>

<style lang="less" scoped>
.Wx-home {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    width: 100%;
  }
  .routerSwitch {
    flex: 1;
  }
  .homeFoolter {
    width: 100%;
    margin-top: 100px;
    padding: 60px 0 20px 0;
    display: flex;
    justify-content: center;
  }
}
</style>
